import { CircularProgress } from '@mui/material'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useState } from 'react'
import TextError from '../../../Components/HealthInsFormikComponent/TextError'
import DobCKYC from './DobCKYC'

import * as Yup from "yup";
import axios from 'axios'
import Swal from 'sweetalert2'
import axiosInstance from '../../../Utilities/djangoAxiosInstance'


const careReqCKYC = {
    "getCkycEkycInputIO": {
        "panNum": "DNJPS0097E",
        "document_type": "PAN",
        "id_number": "",
        "consent_purpose": "this is a consent purpose string pass anything",
        "dob": "1991-01-08"
    }
}


const FormCKYC = (props) => {
    
    const { setCKYC, CKYC, EKYC, setEKYC, setNext, decryptedResponseId, decryptedAcuvisor_product_id,quickQuoteDetails } = props
    const [submitForm, setSubmitForm] = useState(false)

    const initialValues = {
        'panNo': '',
        'dob': '',
    }
console.log('quickQuoteDetails',quickQuoteDetails)
    const validationSchema = Yup.object().shape({
        panNo: Yup.string()
            .required('Pan Number Required')
            .matches(/([A-Z]){5}([0-9]){4}([A-Z]){1}$/, 'Please Give valid Pan Number')
            .min(10, 'Pan Number must have 10 digits')
            .max(10, 'Pan Number must not exceed 10 digits'),
        dob: Yup.string()
            .required('Date of Birth Required')
    })

    const onSubmit = async (data) => {
        console.log('sub', data)
        setSubmitForm(true)
        let req = {
            ...careReqCKYC,
            getCkycEkycInputIO: {
                ...careReqCKYC.getCkycEkycInputIO,
                ['panNum']: data.panNo,
                ['dob']: data.dob
            }
        }

        console.log('req', req)

        let domain = ''

        if (window.location.hostname === 'localhost') {
            domain = process.env.REACT_APP_LOCAL_DJANGO
        }else if (window.location.hostname.trim() === 'it.acuvisor.com') {
            domain = process.env.REACT_APP_PRODUCTION_DJANGO
        }else{
            domain = process.env.REACT_APP_UAT_DJANGO
        }


        await axiosInstance.post(`/api/health-insurance/care/ckyc/${decryptedAcuvisor_product_id}/${decryptedResponseId}/${quickQuoteDetails.A_id}/`, JSON.stringify(req)).then(
            response => {
                if (response.data.message === "Your KYC is verified ") {
                    console.log('Succes')
                    Swal.fire({
                        icon: 'success',
                        title: `${response.data.message}`,
                        text: 'Click on Next button to proceed',
                        position: 'center',

                        showClass: {
                            popup: 'animate__animated animate__fadeInDown'
                        },
                        hideClass: {
                            popup: 'animate__animated animate__fadeOutUp'
                        }

                    }).then(result => {
                        if (result.isConfirmed) {
                            setSubmitForm(false)
                            setNext(false)

                        }

                    })
                }
                console.log('response', response)
            }
        ).catch((error, response) => {

            if (error.response.status === 400) {
                let errMSG = ''
                if (Array.isArray(error.response.data.message)) {
                    errMSG = error.response.data.message[0].errDescription
                } else {
                    errMSG = error.response.data.message
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: `${errMSG}`,
                    position: 'center',
                    showConfirmButton: true,
                    confirmButtonText: 'Do EKYC',
                    showCancelButton: true,
                    cancelButtonText: 'Re-Enter PAN',
                    showClass: {
                        popup: 'animate__animated animate__fadeInDown'
                    },
                    hideClass: {
                        popup: 'animate__animated animate__fadeOutUp'
                    }

                }).then(result => {
                    if (result.isConfirmed) {
                        setCKYC(false)
                        setEKYC(true)
                        setSubmitForm(false)
                    } else if (result.dismiss === "cancel") {
                        setSubmitForm(false)
                        setCKYC(true)
                        setEKYC(false)
                    }
                    console.log(result, 'ff')

                })
                // alert()
                setCKYC(true)
                setEKYC(false)

            }
            console.log('err', error.response)
            setSubmitForm(false)

        }) 
        //setCKYC(false)
        //setEKYC(true)
    }

    return (
        <div>
            {
                CKYC &&
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={onSubmit}
                >
                    {(formik) => (

                        <Form >
                            {console.log('formik', formik)}
                            <div className="form-container ">
                                <div className="d-flex justify-content-center">
                                    <h3>Individual Search CKYC</h3>
                                </div>
                                <div className="form-group  " style={{ paddingTop: '20px' }}>
                                    <label htmlFor="panNo" className="fw-light" style={{ paddingBottom: '8px' }}>Pan Number</label>
                                    <div className='input-icons'>
                                        <Field type="text" name='panNo' id="panNo"
                                            className={
                                                formik.touched.panNo && formik.errors.panNo ? " errorStyle form-control bg-white"
                                                    : !formik.errors.panNo && formik.touched.panNo ? " successField form-control bg-white"
                                                        : " form-control bg-white"
                                            }

                                        />
                                    </div>
                                    <ErrorMessage name='panNo' component={TextError} />

                                </div>
                                <div className="form-group mb-3 " style={{ paddingTop: '20px' }}>
                                    <label htmlFor="dob" className="fw-light" style={{ paddingBottom: '8px' }}>Date of Birth</label>
                                    <div className='input-icons'>
                                        <Field type="text" name='dob' id="dob"
                                            className={
                                                formik.touched.dob && formik.errors.dob ? " errorStyle form-control bg-white"
                                                    : !formik.errors.dob && formik.touched.dob ? " successField form-control bg-white"
                                                        : " form-control bg-white"
                                            }
                                            component={DobCKYC}
                                        />
                                    </div>
                                    <ErrorMessage name='dob' component={TextError} />

                                </div>


                                <div className='mt-3'>
                                    {
                                        !submitForm ?
                                            <button className="submitBtn text-capitalize " type="submit"
                                            //disabled={formik.isSubmitting}
                                            >
                                                Submit
                                            </button>
                                            :
                                            <div className='d-flex justify-content-center'>
                                                <CircularProgress
                                                    size={48}
                                                    sx={{
                                                        color: 'red',

                                                    }} />
                                            </div>
                                    }

                                </div>

                            </div>

                            {/*  <div className=" btn-sec  position-fixed bottom-0 ">
                            {
                                formik.isSubmitting ?
                                    <div className='mx-auto'>
                                        <CircularProgress
                                            size={48}
                                            sx={{
                                                color: 'red',

                                            }} />
                                    </div>

                                    :
                                    <>
                                        <button className="reset-btn text-capitalize"
                                            type="reset"
                                        //onClick={()=>resetForm()}
                                        >
                                            Reset
                                        </button>
                                        <button className="submitBtn text-capitalize " type="submit" disabled={formik.isSubmitting}>
                                            Submit
                                        </button>
                                    </>

                            }
                        </div> */}
                        </Form>
                    )}
                </Formik>
            }

        </div>
    )
}

export default FormCKYC